// eslint-disable-next-line @typescript-eslint/no-var-requires
export const classNames = require('classnames');
